import { useEffect } from 'react';

import { isMobileLikeDevice } from '../lib/isMobileLikeDevice';
import { useRecordingMobileLockModalStore } from './useRecordingMobileLockModalStore';

export const useArmRecordingMobileLock = (): void => {
  const open = useRecordingMobileLockModalStore((s) => s.open);
  const dismissedThisSession = useRecordingMobileLockModalStore((s) => s.dismissedThisSession);

  useEffect(() => {
    if (dismissedThisSession) return;
    if (!isMobileLikeDevice()) return;
    open();
  }, [dismissedThisSession, open]);
};
